<template>
  <div class="nav_div">
    <div class="nav_left">

      <Tooltip :content="back_msg()" placement="left-end">
        <div class="close_div" @click="click_back()">
          <Icon :type="back_icon" size="24" color="white" />
        </div>
      </Tooltip>

      <div class="logo">
        <div class="logo_inner">
          <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
          <span class="logo_txt" @click="click_title">{{ title }}</span>
        </div>

        <span class="bias">/</span>

        <span class="sys_name" @click="click_sys_name">{{ sys_name02 }}</span>

        <span class="bias">/</span>

        <span class="page_name">{{ nav_name }}</span>

        <!-- 头部链接 -->
        <div class="top_link" v-if="top_link_list.length > 0">
          <span class="top_split_txt"> | </span>
          <div class="top_link_div">
            <div
              draggable="true"
              @dragstart="dragStart(index, $event)"
              @drop="drop(index, $event)"
              @dragover.prevent
              @dragenter.prevent
              :class="item.is_select == 1 ? 'top_link2_1' : 'top_link2'"
              v-for="(item, i) in top_link_list"
              :key="i"
              @click="click_top_link(item, i)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="userinfo_div">
      <Tooltip content="工作台" placement="bottom-end">
        <div @click="go_workbench">
          <span class="iconfont icongongzuotai"></span>
        </div>
      </Tooltip>

      <Tooltip content="消息中心" placement="bottom-end">
        <div class="tongzhi_icon_div" @click="click_msg" title="消息中心">
          <span class="iconfont icontongzhi tongzhi_icon"></span>

          <span class="tongzhi_count" style="right: -5px" v-if="msg_count > 0 && msg_count < 10">
            {{ msg_count }}
          </span>

          <span class="tongzhi_count" style="right: -10px" v-if="msg_count >= 10 && msg_count < 99">
            {{ msg_count }}
          </span>

          <span class="tongzhi_count" style="right: -15px" v-if="msg_count >= 99">
            {{ msg_count }}
          </span>
        </div>
      </Tooltip>

      <Tooltip content="个人中心" placement="bottom-end">
        <div class="user_info_main" @click="click_user_info" title="个人中心">
          <div class="userinfo_div_img">
            <img :src="userinfo.avatar" class="avatar" alt="" />
          </div>
          <span class="username">{{ userinfo.name }}</span>
        </div>
      </Tooltip>
    </div>

    <!-- 播放音频 -->
    <audio id="notify_mp3_url" controls v-if="notify_mp3_show">
      <source :src="notify_mp3_url" type="audio/mpeg" />
    </audio>

    <div class="watermark_div" v-if="userinfo.watermark_txt">
      <Watermark
        :content="userinfo.watermark_txt"
        :rotate="-30"
        :z-index="1000"
        :textStyle="userinfo.watermark_text_style"
      ></Watermark>
    </div>
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http";
import Watermark from '@/component/watermark/watermark.vue'

export default {
  name: "menu2",
  props: ["page_name", "back_icon", "back_type", 'sys_name'],
  components: {
    Watermark
  },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      sys_name01: process.env.VUE_APP_SYS_NAME,
      sys_name02: '',
      nav_name: "",

      userinfo: {},

      // 消息数量
      msg_count: 0,

      // 消息通知声音
      notify_mp3_show: false,
      notify_mp3_url: "",

      // 头部链接
      top_link_list: [],
      current_drag: {},
    };
  },

  activated() {
    this.get_collect();
  },

  mounted() {
    this.get_user_data();
    this.get_mp3_notify();
    this.post_msg_count();   // ✅ 只请求一次消息数量
    this.get_collect();

    const meta = this.$route.meta;
    this.nav_name = this.page_name || meta.title;
    this.sys_name02 = this.sys_name || this.sys_name01;
  },

  beforeDestroy() {
    // ✅ 无任何 ws / timer 需要清理
  },

  methods: {
    drop(index, event) {
      const dropTarget = event.target.closest(".top_link_div > div");
      const dropIndex = Array.from(dropTarget.parentNode.children).indexOf(dropTarget);

      const new_list = [];
      for (const item of this.top_link_list) {
        if (item.id !== this.current_drag.id) {
          new_list.push(item);
        }
      }

      new_list.splice(dropIndex, 0, this.current_drag);

      const weight_obj = {};
      new_list.forEach((item, i) => {
        weight_obj[item.id] = i;
      });

      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/staff/user_index/v2/update_collect_weight",
        { weight_dict: weight_obj },
        true
      ).then(res => {
        if (res.code === 0) {
          this.get_collect();
          this.$Message.success({ content: res.msg, duration: 3 });
        } else {
          this.$Message.error({ content: res.msg, duration: 3 });
        }
      }).catch(() => {
        console.log("请求出错");
      });
    },

    dragStart(index, event) {
      const dropTarget = event.target.closest(".top_link_div > div");
      const dropIndex = Array.from(dropTarget.parentNode.children).indexOf(dropTarget);
      this.current_drag = this.top_link_list[dropIndex];
    },

    click_title() {
      open_new_page(process.env.VUE_APP_V2_INDEX_URL + "?page=workbench", "_self");
    },

    click_sys_name() {
      open_new_page(process.env.VUE_APP_V2_INDEX_URL + "?page=workbench", "_self");
    },

    get_collect() {
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/staff/user_index/v2/my_collect_link",
        { host: window.location.host },
        true
      ).then(res => {
        if (res.code === 0) {
          this.top_link_list = res.data.link_list;
          this.refresh_top_link();
        } else {
          this.$Message.error({ content: res.msg, duration: 3 });
        }
      });
    },

    refresh_top_link() {
      const path = this.$route.path;
      this.top_link_list.forEach(item => {
        item.is_select = path === item.path ? 1 : 0;
      });
    },

    get_mp3_notify() {
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/message/notify_mp3",
        {},
        true
      ).then(res => {
        if (res.code === 0) {
          this.notify_mp3_url = res.data.mp3_url;
        }
      });
    },

    show_message_notify() {
      this.$Notice.config({ top: 50, duration: 2 });
      this.$Notice.warning({
        title: "您有新消息，请及时查看！"
      });
    },

    // ✅ 只请求一次消息数量
    post_msg_count() {
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/message/v1/message_count",
        {
          platform:'WEB'
        },
        true
      ).then(res => {
        if (res.code === 0) {
          this.msg_count = res.data.msg_count || 0;
          if (this.msg_count > 0) {
            this.show_message_notify();
          }
        }
      });
    },

    get_user_data() {
      http(
        "post",
        process.env.VUE_APP_V2_AUTH_HOST + "/staff/user_index/v2/nav_user_info",
        {},
        true
      ).then(res => {
        if (res.code === 0) {
          this.userinfo = res.data.user_info;
        }
      });
    },

    back_msg() {
      return this.back_type === "back" ? "返回上一页" : "关闭当前页面";
    },

    click_back() {
      if (this.back_type === "back") {
        if (window.history.length > 1) {
          this.$router.go(-1);
        } else {
          open_new_page(process.env.VUE_APP_V2_INDEX_URL + "?page=workbench", "_self");
        }
      } else {
        window.close();
      }
    },

    click_msg() {
      open_new_page(process.env.VUE_APP_V2_INDEX_URL + "?page=message", "_self");
    },

    click_user_info() {
      open_new_page(process.env.VUE_APP_V2_INDEX_URL + "?page=uinfo", "_self");
    },

    click_top_link(item) {
      open_new_page(item.url, "_self");
    },

    go_workbench() {
      const url = process.env.NODE_ENV === 'development'
        ? 'http://127.0.0.1:8002/user/index/v2?page=workbench'
        : 'https://auth.daxiangsys.com/user/index/v2?page=message';
      open_new_page(url, "_self");
    }
  }
};
</script>

<style scoped>
/* 样式完全保持不变 */
.watermark_div {
  box-sizing: border-box;
  position: fixed;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  z-index: 99999;
  top: 0;
  left: 0;
  pointer-events: none;
}

.top_link_div {
  display: flex;
  align-items: center;
}

.top_link2 {
  font-size: 13px;
  cursor: pointer;
  color: #b1b1b1;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.top_link2_1 {
  font-size: 13px;
  cursor: pointer;
  color: #f4f4f4;
  background: #105ab4;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.top_link2:hover {
  color: rgb(223, 217, 217);
  background: #104a919d;
}

.top_split_txt {
  color: #f0f0f03e;
  margin: 0 10px;
}

.user_info_main {
  display: flex;
  align-items: center;
}

#notify_mp3_url {
  display: none;
}

.tongzhi_count {
  background: red;
  color: #fff;
  font-size: 10px;
  position: absolute;
  top: 0;
  padding: 1px 8px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icongongzuotai {
  font-size: 18px;
  color: #f2f2f2;
  margin-right: 15px;
}

.icongongzuotai:hover {
  color: #92a0ff;
}

.tongzhi_icon_div {
  margin-right: 20px;
  padding: 0 10px;
  position: relative;
}

.tongzhi_icon_div:hover span {
  color: #92a0ff;
}

.tongzhi_icon {
  color: #f2f2f2;
  font-size: 20px;
}

.userinfo_div_img {
  margin-right: 5px;
  padding-top: 5px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ccc;
}

.userinfo_div {
  display: flex;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
}

.username {
  color: #f2f2f2;
}

.bias {
  color: #9591c8;
}

.logo_inner {
  display: flex;
  align-items: center;
}

.logo_img {
  width: 28px;
  height: 28px;
  margin-bottom: 3px;
  margin-right: 5px;
}

.logo_txt {
  cursor: pointer;
  margin-right: 5px;
  font-size: 14px;
}

.logo_txt:hover {
  font-weight: 600;
  color: #fff;
}

.page_name {
  font-size: 14px;
  margin-left: 5px;
  cursor: pointer;
}

.page_name:hover {
  font-weight: 600;
  color: #fff;
}

.sys_name {
  padding: 0 5px;
  cursor: pointer;
  font-size: 14px;
}

.sys_name:hover {
  font-weight: 600;
  color: #fff;
}

.logo {
  color: #e3e3e3;
  font-size: 16px;
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.nav_left {
  display: flex;
  align-items: center;
}

.close_div {
  height: 40px;
  width: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
  background: #1957a2;
  cursor: pointer;
}

.close_div:hover {
  background: rgb(221, 1, 1);
}

.nav_div {
  height: 40px;
  background: #003576;
  position: absolute;
  width: 100%;
  top: 0;
  box-shadow: 0 3px 3px #dbdbdb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>